"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zohoProductKeys = exports.zohoContactKeys = exports.zohoAccountKeys = exports.listingStatus = exports.equipmentOptions = exports.PurchaseMethod = exports.SubCollection = exports.ExemptionType = exports.Collection = exports.autoRenew = exports.publishAuction = exports.listingType = exports.applicationStatus = exports.newOrUsedEquipment = exports.feedbackTags = exports.productStatus = exports.Status = exports.AccountTypes = exports.adminRole = exports.inspectionStatus = exports.offerStatus = exports.alertTypes = exports.messageTypes = exports.dealStage = exports.Environment = void 0;
var Environment;
(function (Environment) {
    Environment["DEVELOPMENT"] = "development";
    Environment["PRODUCTION"] = "production";
    Environment["STAGING"] = "staging";
})(Environment || (exports.Environment = Environment = {}));
var dealStage;
(function (dealStage) {
    dealStage["InterestedInBuying"] = "interested in buying";
    dealStage["InspectionCompleted"] = "inspection completed";
    dealStage["InspectionRequested"] = "inspection requested";
    dealStage["InspectionAccepted"] = "inspection accepted";
    dealStage["InspectionRejected"] = "inspection rejected";
    dealStage["NoLongerInterested"] = "no longer interested";
    dealStage["OfferSubmitted"] = "offer submitted";
    dealStage["OfferAccepted"] = "offer accepted";
    dealStage["OfferCountered"] = "offer countered";
    dealStage["OfferDeclined"] = "offer declined";
    dealStage["BidSubmitted"] = "bid submitted";
    dealStage["AuctionWon"] = "auction won";
    dealStage["AuctionPaymentFailed"] = "auction payment failed";
    dealStage["ReserveNotMet"] = "reserve not met";
    dealStage["AuctionEndedNoSale"] = "auction ended - no sale";
    dealStage["EquipementPurchased"] = "equipment purchased";
    dealStage["LiensSearched"] = "liens searched";
    dealStage["LiensReleased"] = "liens released";
    dealStage["BuyerPaymentSubmitted"] = "buyer payment submitted";
    dealStage["FundsReceived"] = "funds received";
    dealStage["ReleaseNoticeSent"] = "release notice sent";
    dealStage["EquipementPickedUp"] = "equipment picked up";
    dealStage["SellerPaid"] = "seller paid";
    dealStage["SellerReceived"] = "seller received";
    dealStage["Closed"] = "closed";
    dealStage["LostBid"] = "lost bid";
    dealStage["HoldReceived"] = "hold received";
    dealStage["HoldWaived"] = "hold waived";
    dealStage["HoldDeclined"] = "hold declined";
})(dealStage || (exports.dealStage = dealStage = {}));
var messageTypes;
(function (messageTypes) {
    messageTypes["TEXT"] = "text";
    messageTypes["OFFER"] = "offer";
    messageTypes["INSPECTION"] = "inspection";
})(messageTypes || (exports.messageTypes = messageTypes = {}));
var alertTypes;
(function (alertTypes) {
    alertTypes["OfferReceiver"] = "offer receiver";
    alertTypes["OfferSender"] = "offer sender";
    alertTypes["InspectionReceiver"] = "inspection receiver";
    alertTypes["InspectionSender"] = "inspection sender";
    alertTypes["ProductSold"] = "product sold";
    alertTypes["ParticipantLeft"] = "participant left";
    alertTypes["OfferCountered"] = "offer countered";
    alertTypes["CounterofferAccepted"] = "counteroffer accepted";
    alertTypes["CounterofferRejected"] = "counteroffer rejected";
})(alertTypes || (exports.alertTypes = alertTypes = {}));
var offerStatus;
(function (offerStatus) {
    offerStatus["ACCEPTED"] = "accepted";
    offerStatus["REJECTED"] = "rejected";
    offerStatus["COUNTERED"] = "countered";
    offerStatus["WITHDRAWN"] = "withdrawn";
    offerStatus["PENDING"] = "pending";
    offerStatus["EDITIED"] = "edited";
    offerStatus["EXPIRED"] = "expired";
    offerStatus["Sold"] = "sold";
    offerStatus["COUNTER_PENDING"] = "counter pending";
    offerStatus["COUNTER_ACCEPTED"] = "counter offer accepted";
    offerStatus["COUNTER_EDITIED_BUYER"] = "counter offer edited by buyer";
    offerStatus["COUNTER_EDITIED_SELLER"] = "counter offer edited by seller";
    offerStatus["COUNTER_REJECTED"] = "counter offer rejected";
    offerStatus["COUNTER_WITHDRAWN"] = "counter offer withdrawn";
})(offerStatus || (exports.offerStatus = offerStatus = {}));
var inspectionStatus;
(function (inspectionStatus) {
    inspectionStatus["REJECTED"] = "rejected";
    inspectionStatus["PENDING"] = "pending";
    inspectionStatus["DONE"] = "done";
})(inspectionStatus || (exports.inspectionStatus = inspectionStatus = {}));
var adminRole;
(function (adminRole) {
    adminRole["superManager"] = "superManager";
    adminRole["superAdmin"] = "superAdmin";
    adminRole["MSA"] = "MSA";
})(adminRole || (exports.adminRole = adminRole = {}));
var AccountTypes;
(function (AccountTypes) {
    AccountTypes["Customer"] = "Customer";
    AccountTypes["Lender"] = "Lender";
    AccountTypes["Manufacturer"] = "Manufacturer";
    AccountTypes["Other"] = "Other";
    AccountTypes["Services"] = "Services";
    AccountTypes["Transport and Vendor"] = "Transport and Vendor";
})(AccountTypes || (exports.AccountTypes = AccountTypes = {}));
var Status;
(function (Status) {
    Status["Pending"] = "Pending";
    Status["RequestedChanges"] = "RequestedChanges";
    Status["Rejected"] = "Rejected";
    Status["Approved"] = "Approved";
})(Status || (exports.Status = Status = {}));
var productStatus;
(function (productStatus) {
    productStatus["inProgress"] = "inProgress";
    productStatus["Pending"] = "Pending";
    productStatus["Rejected"] = "Rejected";
    productStatus["Approved"] = "Approved";
    productStatus["Sold"] = "Sold";
    productStatus["Canceled"] = "Canceled";
    productStatus["AuctionClosed"] = "AuctionClosed";
})(productStatus || (exports.productStatus = productStatus = {}));
var feedbackTags;
(function (feedbackTags) {
    feedbackTags["Buyer"] = "Buyer";
    feedbackTags["Seller"] = " Seller";
})(feedbackTags || (exports.feedbackTags = feedbackTags = {}));
var newOrUsedEquipment;
(function (newOrUsedEquipment) {
    newOrUsedEquipment["New"] = "New";
    newOrUsedEquipment["Used"] = "Used";
})(newOrUsedEquipment || (exports.newOrUsedEquipment = newOrUsedEquipment = {}));
var applicationStatus;
(function (applicationStatus) {
    applicationStatus["APPLIED"] = "applied";
    applicationStatus["REJECTED"] = "rejected";
    applicationStatus["ACCEPTED"] = "accepted";
})(applicationStatus || (exports.applicationStatus = applicationStatus = {}));
var listingType;
(function (listingType) {
    listingType["BuyNow"] = "Buy Now";
    listingType["Auction"] = "Auction";
})(listingType || (exports.listingType = listingType = {}));
var publishAuction;
(function (publishAuction) {
    publishAuction["NOW"] = "Immediately upon approval";
    publishAuction["LATER"] = "Schedule for later";
})(publishAuction || (exports.publishAuction = publishAuction = {}));
var autoRenew;
(function (autoRenew) {
    autoRenew["ENABLE"] = "Enable";
    autoRenew["DISABLE"] = "Disable";
})(autoRenew || (exports.autoRenew = autoRenew = {}));
var Collection;
(function (Collection) {
    Collection["Accounts"] = "accounts";
    Collection["AchAuthorization"] = "achAuthorization";
    Collection["AdminBankAccountDetails"] = "adminBankAccountDetails";
    Collection["AdminNotifications"] = "adminNotifications";
    Collection["Admins"] = "admins";
    Collection["BuyersPremium"] = "buyersPremium";
    Collection["Categories"] = "categories";
    Collection["Chats"] = "chats";
    Collection["Contacts"] = "contacts";
    Collection["Deals"] = "deals";
    Collection["Feedbacks"] = "feedbacks";
    Collection["Finance"] = "finance";
    Collection["Invoices"] = "invoices";
    Collection["NotificationTemplate"] = "notificationTemplate";
    Collection["Notifications"] = "notifications";
    Collection["Products"] = "products";
    Collection["SalesTax"] = "salesTax";
    Collection["AssetReports"] = "assetReports";
    Collection["TaxExemptionCertificates"] = "taxExemptionCertificates";
    Collection["ZohoSignGeneralMsaAgreement"] = "zohoSignGeneralMsaAgreement";
    Collection["ZohoSignListingAgreement"] = "zohoSignListingAgreement";
    Collection["productViews"] = "productViews";
    Collection["Sectors"] = "sectors";
})(Collection || (exports.Collection = Collection = {}));
var ExemptionType;
(function (ExemptionType) {
    ExemptionType["NonExempt"] = "non_exempt";
    ExemptionType["Wholesale"] = "wholesale";
    ExemptionType["Government"] = "government";
    ExemptionType["Other"] = "other";
})(ExemptionType || (exports.ExemptionType = ExemptionType = {}));
var SubCollection;
(function (SubCollection) {
    SubCollection["AccountAdditionalDetail"] = "accountAdditionalDetails";
    SubCollection["BankAccountInfo"] = "bankAccountInfo";
    SubCollection["Bids"] = "bids";
    SubCollection["Favorites"] = "favorites";
    SubCollection["PersonalDetails"] = "personalDetails";
    SubCollection["PersonalInfo"] = "personalInfo";
    SubCollection["PublicQuestions"] = "publicQuestions";
})(SubCollection || (exports.SubCollection = SubCollection = {}));
var PurchaseMethod;
(function (PurchaseMethod) {
    PurchaseMethod["BuyNow"] = "Buy Now";
    PurchaseMethod["Offer"] = "Offer";
    PurchaseMethod["Bid"] = "Bid";
})(PurchaseMethod || (exports.PurchaseMethod = PurchaseMethod = {}));
var equipmentOptions;
(function (equipmentOptions) {
    equipmentOptions["EquipmentHours"] = "Equipment Hours";
    equipmentOptions["EquipmentMileage"] = "Equipment Mileage";
    equipmentOptions["SerialNumber"] = "Serial Number";
    equipmentOptions["EquipmentVINNumber"] = "Equipment VIN Number";
    equipmentOptions["Unknown"] = "Unknown";
})(equipmentOptions || (exports.equipmentOptions = equipmentOptions = {}));
var listingStatus;
(function (listingStatus) {
    listingStatus["EMAIL_DISPATCHED"] = "E-mail to recipient has been dispatched";
    listingStatus["RECIPIENT_VIEWED"] = "Recipient Viewed";
    listingStatus["RECIPIENT_SIGNED"] = "Recipient Signed";
    listingStatus["CONSIGNEE_VIEWED"] = "Consignee Viewed";
    listingStatus["CONSIGNEE_SIGNED"] = "Consignee Signed";
    listingStatus["RECIPIENT_DECLINED"] = "Recipient Declines Agreement";
    listingStatus["CONSIGNEE_DECLINED"] = "Consignee Declines Agreement";
    listingStatus["RECIPIENT_FORWARDED"] = "Agreement Forwarded to";
    listingStatus["RECALLED"] = "Agreement Recalled";
})(listingStatus || (exports.listingStatus = listingStatus = {}));
var zohoAccountKeys;
(function (zohoAccountKeys) {
    zohoAccountKeys["Zoho_ID"] = "id";
    zohoAccountKeys["Firebase_ID"] = "FirebaseID";
    zohoAccountKeys["Account_Name"] = "Account_Name";
    zohoAccountKeys["Website_URL"] = "Website";
    zohoAccountKeys["Company_Email"] = "Company_Email";
    zohoAccountKeys["Phone"] = "Phone";
    zohoAccountKeys["Shipping_Street"] = "Shipping_Street";
    zohoAccountKeys["Shipping_Street_2"] = "SHIP_ADDRESS2";
    zohoAccountKeys["Shipping_Country"] = "Shipping_Country";
    zohoAccountKeys["Shipping_State"] = "Shipping_State";
    zohoAccountKeys["Shipping_City"] = "Shipping_City";
    zohoAccountKeys["Shipping_Code"] = "Shipping_Code";
    zohoAccountKeys["Billing_Street"] = "Billing_Street";
    zohoAccountKeys["Billing_Street_2"] = "Billing_Street_2";
    zohoAccountKeys["Billing_Country"] = "Billing_Country";
    zohoAccountKeys["Billing_State"] = "Billing_State";
    zohoAccountKeys["Billing_City"] = "Billing_City";
    zohoAccountKeys["Billing_Code"] = "Billing_Code";
    zohoAccountKeys["Parent_Account"] = "Parent_Account";
    zohoAccountKeys["MSA"] = "MSA";
    zohoAccountKeys["Website_Account"] = "Website_User";
    zohoAccountKeys["Sector"] = "Sector";
    zohoAccountKeys["Account_Type"] = "Account_Type";
    zohoAccountKeys["Description"] = "Description";
    zohoAccountKeys["Created_Time"] = "Created_Time";
    zohoAccountKeys["Modified_Time"] = "Modified_Time";
    zohoAccountKeys["Is_Synced"] = "Is_Synced";
})(zohoAccountKeys || (exports.zohoAccountKeys = zohoAccountKeys = {}));
var zohoContactKeys;
(function (zohoContactKeys) {
    zohoContactKeys["Zoho_ID"] = "id";
    zohoContactKeys["Firebase_ID"] = "FirebaseID";
    zohoContactKeys["Account_Name"] = "Account_Name";
    zohoContactKeys["First_Name"] = "First_Name";
    zohoContactKeys["Last_Name"] = "Last_Name";
    zohoContactKeys["Email"] = "Email";
    zohoContactKeys["Title"] = "Title";
    zohoContactKeys["Mobile"] = "Mobile";
    zohoContactKeys["Is_Primary_Contact"] = "Is_Primary_Contact";
    zohoContactKeys["Website_Account"] = "Website_User";
    zohoContactKeys["Created_Time"] = "Created_Time";
    zohoContactKeys["Modified_Time"] = "Modified_Time";
    zohoContactKeys["Is_Synced"] = "Is_Synced";
})(zohoContactKeys || (exports.zohoContactKeys = zohoContactKeys = {}));
var zohoProductKeys;
(function (zohoProductKeys) {
    zohoProductKeys["Zoho_ID"] = "id";
    zohoProductKeys["Firebase_ID"] = "FirebaseID";
    zohoProductKeys["Account_Name"] = "Account_Name";
    zohoProductKeys["Contact_Name"] = "Contact_Name";
    zohoProductKeys["Product_Name"] = "Product_Name";
    zohoProductKeys["Sales_Start_Date"] = "Sales_Start_Date";
    zohoProductKeys["Sales_End_Date"] = "Sales_End_Date";
    zohoProductKeys["Description"] = "Description";
    zohoProductKeys["Equipment_VIN_Number"] = "Equipment_VIN_Number";
    zohoProductKeys["Serial_Number"] = "Serial_Number";
    zohoProductKeys["Equipment_Located_at_Company_Address"] = "Equipment_Located_at_Company_Address";
    zohoProductKeys["Equipment_Hours"] = "Equipment_Hours";
    zohoProductKeys["Equipment_Mileage"] = "Equipment_Mileage";
    zohoProductKeys["Product_Manufacturer"] = "Product_Manufacturer";
    zohoProductKeys["Make_and_Model"] = "Make_and_Model";
    zohoProductKeys["Year"] = "Year";
    zohoProductKeys["Is_Equipment_Free_of_Liens_or_Encumbrances"] = "Is_Equipment_Free_of_Liens_or_Encumbrances";
    zohoProductKeys["Equipment_City"] = "City";
    zohoProductKeys["Equipment_Country"] = "Country";
    zohoProductKeys["Equipment_State"] = "State";
    zohoProductKeys["Equipment_Street"] = "Street";
    zohoProductKeys["Equipment_Zip"] = "Zip";
    zohoProductKeys["Initial_Buy_It_Now_Price"] = "Initial_Buy_It_Now_Price";
    zohoProductKeys["Initial_Reserve_Price"] = "Initial_Reserve_Price";
    zohoProductKeys["Opening_Price"] = "Opening_Price";
    zohoProductKeys["Final_Sale_Price"] = "Final_Sale_Price";
    zohoProductKeys["Asking_Price"] = "Asking_Price";
    zohoProductKeys["Equipment_Type"] = "Equipment_Type";
    zohoProductKeys["Selling_Choice"] = "Selling_Choice";
    zohoProductKeys["New_or_Used_Equipment"] = "New_or_Used_Equipment";
    zohoProductKeys["DADE_Auction_Website_Link"] = "DADE_Auction_Website_Link";
    zohoProductKeys["Commission_Percentage"] = "Commission_Percentage";
    zohoProductKeys["Expected_Revenue"] = "Expected_Revenue";
    zohoProductKeys["Listing_Agreement_Signed"] = "Listing_Agreement_Signed";
    zohoProductKeys["Are_you_capable_of_dismantling_and_loading"] = "Are_you_capable_of_dismantling_and_loading";
    zohoProductKeys["Contract_Duration_Days"] = "Contract_Duration_Days";
    zohoProductKeys["Contract_Term_Duration"] = "Contract_Term_Duration";
    zohoProductKeys["Notification"] = "Notification";
    zohoProductKeys["Is_Synced"] = "Is_Synced";
    zohoProductKeys["Product_Active"] = "Product_Active";
    zohoProductKeys["Modified_Time"] = "Modified_Time";
    zohoProductKeys["Lienholder_Name"] = "Lienholder_Name";
    zohoProductKeys["Lienholder_Email"] = "Lienholder_1_Email";
    zohoProductKeys["Lien_Payoff_Amount"] = "Lien_Payoff_Amount";
    zohoProductKeys["Lienholder_Phone"] = "Lienholder_1_Phone";
    zohoProductKeys["Created_Time"] = "Created_Time";
    zohoProductKeys["Product_Code"] = "Product_Code";
    zohoProductKeys["Deal_Name"] = "Deal_Name";
    zohoProductKeys["Auto_Renew"] = "Auto_Renew";
})(zohoProductKeys || (exports.zohoProductKeys = zohoProductKeys = {}));
